import React from 'react';
import { Dispatch } from 'architecture'
import _ from 'lodash'
import DropZone from 'react-dropzone'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import Textarea from 'react-textarea-autosize';

import Tag from './Tag'

export default (props) => {
  const data = props.data ? props.data : {}
  const target = props.data ? props.data.target : null
  const componentId = data.id + '-tagInput'
  const text = data.text ? data.text : ''
  const key = data.key ? data.key : ''
  const tags = data.tags ? data.tags : {}
  const dragTarget = props.dragTarget ? props.dragTarget : {}
  const dragging = props.dragging ? true : false
  const draggedOver = (dragTarget.target === componentId && props.dragTarget.accept === true) ? true : false
  const instance = data.mini ? true : false
  const instanceStyle = instance ? 'flex flex-wrap o-50' : 'bg-white ph1 b--moon-gray br3 ba flex flex-wrap'
  const draggedStyle = draggedOver ? 'h4 bg-near-white' : ''
  const style = instanceStyle

  const onRemove = (tagId) => Dispatch.nextAction(target, 'removeTag', { id: data.id, tag: tagId })
  return (
    <div className={style + ' items-center'} style={{minHeight: 45}}>
        { Object.keys(tags).map((key, index) => <Tag key={index} {...props} data={{ onRemove: onRemove, id: key, tag: tags[key] }} />)}
        <div className='w4' style={{flexGrow:1}}>
        { (dragging && data.type === 'stream') ?
          <MyDropzone /> 
          :
          // <div
            
          //   id={data.id}
          //   onChange={(e) => Dispatch.nextAction(target, 'onChange', { id: data.id, value: e.target.value})}
          //   onBlur={(e) => Dispatch.nextAction(target, 'onBlur', { id: data.id, event: e } )}
          //   onKeyPress={(e) => Dispatch.nextAction(target, 'onKeyPress', { id: data.id, value: e.key})}
          //   onFocus={(e) => Dispatch.nextAction(target, 'onFocus', { id: data.id })}
          //   className='TagInput' 
          //   style={{minHeight: 25, outline: 'none'}} 
          //   contentEditable="true"
          //   >
          //     {/* <Linkify>{props.data.text}</Linkify> */}
          //     {text}
          // </div>
          <Textarea 
            key={key}
            id={data.id}
            onChange={(e) => Dispatch.nextAction(target, 'onChange', { id: data.id, value: e.target.value })}
            onBlur={(e) => Dispatch.nextAction(target, 'onBlur', { id: data.id, event: e } )}
            onKeyPress={(e) => {
              console.log(e)
              if(e.key === 'Enter' && e.shiftKey !== true) {
                e.preventDefault();
              }
              Dispatch.nextAction(target, 'onKeyPress', { id: data.id, value: e.key})}
            }
            onFocus={(e) => Dispatch.nextAction(target, 'onFocus', { id: data.id })}
            className='input-reset pl1 w-100 bg--transparent TagInput'
            style={{border: 'none', outline: 'none', resize: 'none'}}
            defaultValue={text}
            autofocus
            placeholder='@'
          />
          // <input 
          //   id={data.id}
          //   className={'input-reset br2 pl1 w-100 bn bg--transparent f4 TagInput'}
          //   placeholder={'@' }
          //   value={text}
          //   style={{outline: 'none'}}
          //   type='text'
          //   onChange={(e) => Dispatch.nextAction(target, 'onChange', { id: data.id, value: e.target.value})}
          //   onBlur={(e) => Dispatch.nextAction(target, 'onBlur', { id: data.id, event: e } )}
          //   onKeyPress={(e) => Dispatch.nextAction(target, 'onKeyPress', { id: data.id, value: e.key})}
          //   onFocus={(e) => Dispatch.nextAction(target, 'onFocus', { id: data.id })}
          // />
          
        }
        </div>
        {/* { draggedOver ? < } */}
      </div>
  )
}

class MyDropzone extends React.Component {
  onDrop = (acceptedFiles, rejectedFiles) => {
    Dispatch.nextAction('upload', 'file', acceptedFiles[0])
  }

  onLeave = () => {
    Dispatch.nextState('dragTarget', {})
    return <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
  }
  render() {
   return (
     <DropZone onDrop={this.onDrop}>
       {({getRootProps, getInputProps, isDragActive}) => {
         return (
           <div
             {...getRootProps()}
           >
             <input {...getInputProps()} />
             <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
             {/* { isDragActive ?
                <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
                 //<p>Drop files here...</p> :
                : <div className='h5 bg-near-white f1 gray flex justify-center items-center'> <FontAwesomeIcon icon={faUpload}/> </div>
             } */}
           </div>
         )
       }}
     </DropZone>
   );
 }
}